export const volumeOff = {
	className: 'icon-volume-off',
	viewBox: '0 0 384 384',
	paths: [
		'm 341.5,192 c 0,22.717 -4.883,44.362 -13.603,63.855 l 31.88,31.88 C 375.283,259.33 384,226.653 384,192 384,98.744 320,19.746 235,0 l 0,44.978 C 297,63.632 341.5,122.882 341.5,192 Z M 192,16.458 140.979,68.938 192,119.957 Z M 356.842,332.885 27.116,3.157 l -24,24 L 93.615,117.57 85.335,128 0,128 0,256 85.334,256 192,367.543 192,216 286.915,310.686 C 271.795,323.443 254,333.213 235,339.022 L 235,384 c 31,-7.172 58.996,-22.163 82.315,-42.809 l 39.61,39.693 24,-24.043 -24.002,-24.039 -0.081,0.083 z',
		'M 288.188,192 C 288.188,153.601 267,119.593 235,103.137 l 0,59.82 50.801,50.801 A 100.596,100.596 0 0 0 288.188,192 Z'
	]
}
